import { Euler } from 'three';

/** Character and BVH assets are typically authored Y-up. */
export const DEFAULT_MOTION_SCENE_CHARACTER_ROTATION = new Euler(
  -Math.PI / 2,
  0,
  0,
);
